import ODataUtil from "./ODataUtil";
import { deleteItem, patchItem, postItem, ApiRequest } from './ApiUtils';
import CommunicationEvent from 'classes/CommunicationEvent';
import buildQuery from 'odata-query';

const communicationEventEndpoint = "/CommunicationEvent";

/**
 * Get communication events with OData query support
 */
async function getCommunicationEvents(page, per_page, orderByInfo, orderByDirection, search, filters) {
  try {
    const { skip, count, top, expand, orderBy, mappedFilter } = ODataUtil.UtilityBuilderNestedv3(
      per_page, page, CommunicationEvent.expand, orderByInfo, orderByDirection, filters
    );
    const filter = {};
    const isDefaults = filters.find(r => r.defaults);

    if (isDefaults) {
      const defaults = isDefaults.defaults;
      if(defaults.projectId) filter["ihwi/workItem/projectId"] = { eq: { type: 'guid', value: defaults.projectId }};
      if(defaults.inspectionNumber) filter["ihwi/inspection/inspectionNumber"] = defaults.inspectionNumber;
    }

    const allFilters = mappedFilter.reduce((a, b) => ({...a, ...b}), filter);
    const params = buildQuery({ count, top, skip, orderBy, expand, filter: allFilters });

    const data = await ApiRequest(communicationEventEndpoint, params);
    return CommunicationEvent.convertToTableRows(data);
  } catch (error) {
    console.error('Error fetching communication events:', error);
    throw error;
  }
}

/**
 * Add a new communication event
 */
async function addCommunicationEvent(data) {
  try {
    const resourcePath = `${communicationEventEndpoint}/Add`;
    const result = await postItem(resourcePath, '', data);
    return result;
  } catch (error) {
    console.error('Error adding communication event:', error);
    throw error;
  }
}

/**
 * Update an existing communication event
 */
async function updateCommunicationEvent(communicationEventId, data) {
  try {
    const resourcePath = `${communicationEventEndpoint}/Update`;
    const params = `?communicationEventId=${communicationEventId}`;
    const result = await patchItem(resourcePath, params, data);
    return result;
  } catch (error) {
    console.error('Error updating communication event:', error);
    throw error;
  }
}

/**
 * Delete a communication event
 */
async function deleteCommunicationEvent(communicationEventId) {
  try {
    const resourcePath = `${communicationEventEndpoint}/Delete`;
    const params = `?communicationEventId=${communicationEventId}`;
    const result = await deleteItem(resourcePath, params);
    return result;
  } catch (error) {
    console.error('Error deleting communication event:', error);
    throw error;
  }
}

/**
 * Get a specific communication event by ID
 */
async function getCommunicationEventById(communicationEventId) {
  try {
    const expand = CommunicationEvent.expand;
    const { expand: expandQuery } = ODataUtil.UtilityBuilderNestedv3(
      1,
      0,
      expand,
      null,
      null,
      []
    );

    const params = buildQuery({
      expand: expandQuery,
      filter: { CommunicationEventId: { eq: { type: 'guid', value: communicationEventId } } }
    });

    const response = await fetch(`${communicationEventEndpoint}${params}`);
    const result = await response.json();

    if (result.value && result.value.length > 0) {
      return new CommunicationEvent(result.value[0]);
    }

    return null;
  } catch (error) {
    console.error('Error fetching communication event by ID:', error);
    throw error;
  }
}

export {
  getCommunicationEvents,
  addCommunicationEvent,
  updateCommunicationEvent,
  deleteCommunicationEvent,
  getCommunicationEventById
};
